<template>
  <div>
    <div class="grid grid-cols-1 gap-4 mb-1">
      <div>
        <top-page-notifications-provider></top-page-notifications-provider>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <div>
        <top-active-provider></top-active-provider>
      </div>
      <div>
        <top-page-receipt-provider></top-page-receipt-provider>
      </div>
    </div>
  </div>
  <budget-dialog v-if="isOpen && type === 'budgets'"></budget-dialog>
  <receipt-dialog-provider
    v-if="isOpen && type === 'receipt'"
  ></receipt-dialog-provider>
  <activities-dialog-provider
    v-if="isOpen && type === 'politicalAction'"
  ></activities-dialog-provider>
</template>

<script>
import BudgetDialog from '@/components/layout/budgets/BudgetDialog.vue'
import ActivitiesDialogProvider from '@/components/provider/ActivitiesDialogProvider'
import ReceiptDialogProvider from '@/components/provider/ReceiptDialogProvider'
import TopPageReceiptProvider from '@/components/provider/TopPageReceiptProvider'
import TopPageNotificationsProvider from '@/components/provider/TopPageNotificationsProvider'
import { useDialog } from '@/services/useDialog'
import TopActiveProvider from '@/components/provider/topActiveProvider/TopActiveProvider'

export default {
  name: 'Top',

  components: {
    BudgetDialog,
    ActivitiesDialogProvider,
    ReceiptDialogProvider,
    TopPageReceiptProvider,
    TopPageNotificationsProvider,
    TopActiveProvider,
  },
  setup() {
    const { isOpen, type } = useDialog()
    return { isOpen, type }
  },
}
</script>

<style lang="scss"></style>
